export const getRazorpayCredentials = () => {
  const mode = process.env.REACT_APP_PUBLIC_RAZORPAY_MODE;
  const isLive = mode === "LIVE";

  return {
    keyId: isLive
      ? process.env.REACT_APP_RAZORPAY_KEY_ID_LIVE
      : process.env.REACT_APP_RAZORPAY_KEY_ID_TEST,

    keySecret: isLive
      ? process.env.REACT_APP_RAZORPAY_KEY_SECRET_LIVE
      : process.env.REACT_APP_RAZORPAY_KEY_SECRET_TEST,
  };
};
